<div class="body-container-wrapper">
    <section class="customer-review-banner bgwhite">
           <app-customer-review-banner></app-customer-review-banner>
        </section>
        <section class="banner-bottom-pane section-banner">
            <div class="container">
                <ul class="d-flex justify-content-between section-banner">
                    <li>
                        <div class="facebook-followers-card">
                            <img src="../../assets/images/customer-review/facebook-logo.png" alt="">
                            <span>247,517 followers</span>
                        </div>
                        <h5>for BajajCapital</h5>
                    </li>
                
                    <li>
                        <div class="mouthshut-card">
                            <img src="../../assets/images/customer-review/mouthshut-logo.png" alt="">
                            <span>77%
                                <span class="star">
                                    <i class="fas fa-heart"></i>
                                </span>
                            </span>
                        </div>
                        <h5>for BajajCapital</h5>
                    </li>
                    <li>
                        <div class="ambition-card">
                            <img src="../../assets/images/customer-review/ambition-logo.jpg" alt="">
                            <span>4.1 
                                <span class="star">
                                    <i class="fas fa-star"></i>
                                    <i class="fas fa-star"></i>
                                    <i class="fas fa-star"></i>
                                    <i class="fas fa-star-half-alt"></i>
                                    <i class="far fa-star"></i>
                                </span>
                            </span>
                        </div>
                        <h5>for BajajCapital Insurance</h5>
                    </li>
                </ul>
            </div>
        </section>
        <section>
           <app-sm-reviews></app-sm-reviews>
        </section>
        <section class="qyery-form-section bgwhite" id="query-form">
           <app-customer-review-leadform></app-customer-review-leadform>
        </section>
    <section class="darkgreybg">
        <app-media-mentions></app-media-mentions>
    </section>
       
    <section class="search-section container">
        <app-product-service-search></app-product-service-search>
    </section>
       
    </div>
